module.exports = __webpack_public_path__ + "static/media/dokia-register.db8de955.svg";